import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getInfoListWidgetStyles = () => {
  return StyleSheet.create({
    dividerStyle: {
      marginHorizontal: -tokens.spacing.SPACING_16
    },
    divider: {
      marginTop: tokens.spacing.SPACING_20
    },
    viewButtonWrapperDiv: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      paddingVertical: tokens.spacing.SPACING_16
    },
    viewButtonWrapperContainer: {
      paddingVertical: tokens.spacing.SPACING_20
    },
    infoListCollapsibleStyle: {
      paddingTop: tokens.spacing.SPACING_20
    },
    customCardPadding: {
      marginHorizontal: tokens.spacing.SPACING_16
    }
  });
};